// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyATkijZXZhnHllZaS8hZkJFcUk6QwgxDuk",
    authDomain: "provenance-310914.firebaseapp.com",
    databaseURL: "https://provenance-310914-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "provenance-310914",
    storageBucket: "provenance-310914.appspot.com",
    messagingSenderId: "1055342744810",
    appId: "1:1055342744810:web:4eeff11095365a3004f393",
    measurementId: "G-0EBNKJV7ZB"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
